// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { CSSProperties } from '@material-ui/styles';
import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { nextFrame } from '../lib/utility';

const MAX_TRANSITION_DURATION = 0.5
const SCROLL_HEIGHT_BREAKPOINT = 100;

interface CollapseTransitionProps extends React.ComponentPropsWithRef<'div'> {
  visible: boolean;
}

const S = {
  Transition: styled.div<{ transition: boolean }>`
    overflow: hidden;
  `
}

const CollapseTransition = (props: CollapseTransitionProps): JSX.Element => {
  const {
    visible,
    children,
    ...otherProps
  } = props;

  const ref = useRef<HTMLDivElement | null>(null);
  const [style, setStyle] = useState<CSSProperties>({
    height: '0px',
    transition: 'height ease-in-out',
    transitionDuration: `${MAX_TRANSITION_DURATION}s`,
  });

  useEffect(() => {
    if (!ref.current) {
      return;
    }

    if (!visible) { // Set height to current height when closing
      setStyle({
        ...style,
        height: ref.current.scrollHeight + 'px',
      })
    }

    nextFrame(() => {
      if (!ref.current) {
        return;
      }

      if (visible) {
        setStyle({
          ...style,
          height: ref.current.scrollHeight + 'px',
        })
      } else {
        setStyle({
          ...style,
          height: '0px',
        })
      }
    });
  }, [visible, ref.current]);

  useEffect(() => { // Update transition duration
    if (!ref.current) {
      return;
    }
    const scrollHeight = ref.current.scrollHeight || 0;
    let transitionDuration;
    if (scrollHeight < SCROLL_HEIGHT_BREAKPOINT) {
      transitionDuration = (MAX_TRANSITION_DURATION * scrollHeight / SCROLL_HEIGHT_BREAKPOINT) + 's'
    } else {
      transitionDuration = MAX_TRANSITION_DURATION + 's';
    }

    if (transitionDuration !== style.transitionDuration) {
      setStyle({
        ...style,
        transitionDuration
      })
    }
  }, [ref.current, children]);

  const handleTransitionEnd = () => {
    if (ref.current && visible) {
      setStyle({
        ...style,
        height: '', // Prevent content height increace after animation ended
      })
    }
  }

  return (
    <S.Transition
      ref={ref}
      transition={true}
      onTransitionEnd={handleTransitionEnd}
      style={style}
      {...otherProps}
    >{children}</S.Transition>
  )
}

export default CollapseTransition;
